import React from 'react';
import { useZoomableMap } from './ZoomableMap';
import './markers.css';

// Convert relative (0-1) position to pixel position within the overlay
function usePixelPosition(position) {
  const { imageRect } = useZoomableMap();
  if (!position) return null;
  return {
    x: imageRect.x + position.x * imageRect.width,
    y: imageRect.y + position.y * imageRect.height,
  };
}

export function GuessMarker({ position, color, size, variant = 'dot' }) {
  const px = usePixelPosition(position);
  if (!px) return null;

  if (variant === 'pin') {
    return (
      <div
        className="zm-marker zm-marker-pin-wrapper"
        style={{ left: `${px.x}px`, top: `${px.y}px` }}
      >
        <div
          className="zm-marker-pin"
          style={color ? { backgroundColor: color } : undefined}
        ></div>
        <div className="zm-marker-shadow"></div>
      </div>
    );
  }

  // Default: dot
  const dotSize = size || 16;
  return (
    <div
      className="zm-marker zm-marker-dot zm-marker-guess"
      style={{
        left: `${px.x}px`,
        top: `${px.y}px`,
        width: `${dotSize}px`,
        height: `${dotSize}px`,
        ...(color ? { backgroundColor: color } : {}),
      }}
    ></div>
  );
}

export function ActualMarker({ position, color, size, variant = 'dot' }) {
  const px = usePixelPosition(position);
  if (!px) return null;

  if (variant === 'star') {
    return (
      <div
        className="zm-marker zm-marker-star"
        style={{ left: `${px.x}px`, top: `${px.y}px` }}
      >
        <svg viewBox="0 0 24 24" width={size || 24} height={size || 24} className="zm-star-icon">
          <polygon
            points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
            fill={color || '#ffd700'}
          />
        </svg>
      </div>
    );
  }

  // Default: dot
  const dotSize = size || 16;
  return (
    <div
      className="zm-marker zm-marker-dot zm-marker-actual"
      style={{
        left: `${px.x}px`,
        top: `${px.y}px`,
        width: `${dotSize}px`,
        height: `${dotSize}px`,
        ...(color ? { backgroundColor: color } : {}),
      }}
    ></div>
  );
}

export function DistanceLine({ from, to, color = '#ffffff', dashed = true }) {
  const pxFrom = usePixelPosition(from);
  const pxTo = usePixelPosition(to);
  if (!pxFrom || !pxTo) return null;

  return (
    <svg className="zm-distance-line">
      <line
        x1={pxFrom.x}
        y1={pxFrom.y}
        x2={pxTo.x}
        y2={pxTo.y}
        stroke={color}
        strokeWidth="2"
        strokeDasharray={dashed ? '5,5' : 'none'}
      />
    </svg>
  );
}

export function PlayerMarker({ position, color, label }) {
  const px = usePixelPosition(position);
  if (!px) return null;

  return (
    <div
      className="zm-marker zm-marker-player"
      style={{
        left: `${px.x}px`,
        top: `${px.y}px`,
        backgroundColor: color,
      }}
      title={label}
    ></div>
  );
}
